import { DH_VOICE_LANGUAGES } from "@/entities/dh-profile/model/voiceV2Options";

/**
 * 1027 测试机:选「한국어」、稿子是中文 → 出片还是普通话。
 * 语言选项只让引擎「用 X 语朗读」,**不翻译稿子**;中文稿配外语,引擎照字念中文。
 * 页面据此在「选了外语 + 稿子还是中文」时提示,并给「一键翻译」(ai script-translate)。
 *
 * 判据与 ai 侧 script_translate「没译成守卫」同口径:汉字占非空白字符 > 20% 算中文稿;
 * 日文本身有汉字,改看有没有假名。
 */
const CJK_RE = /[一-鿿]/g;
const KANA_RE = /[぀-ヿ]/;
const MAX_CJK_RATIO = 0.2;

export function looksUntranslated(script: string, language: string): boolean {
  if (!language || language === "zh") return false;
  const chars = script.replace(/\s/g, "");
  if (!chars) return false;
  const cjk = chars.match(CJK_RE)?.length ?? 0;
  if (language === "ja") return cjk > 0 && !KANA_RE.test(chars);
  return cjk / chars.length > MAX_CJK_RATIO;
}

/** 提示里用中文说语言名(下拉里是母语写法「한국어」,运营不一定认得)。 */
const LANGUAGE_ZH_NAMES: Record<string, string> = {
  en: "英语",
  ja: "日语",
  ko: "韩语",
  ru: "俄语",
  fr: "法语",
  de: "德语",
  pt: "葡萄牙语",
  th: "泰语",
  id: "印尼语",
  vi: "越南语",
  es: "西班牙语",
  it: "意大利语",
  ms: "马来语",
  fil: "菲律宾语",
  ar: "阿拉伯语",
};

export function languageZhName(language: string): string {
  return (
    LANGUAGE_ZH_NAMES[language] ??
    DH_VOICE_LANGUAGES.find((l) => l.value === language)?.label ??
    language
  );
}
